import { render, staticRenderFns } from "./MyShop.vue?vue&type=template&id=4c92f327&scoped=true&"
import script from "./MyShop.vue?vue&type=script&lang=js&"
export * from "./MyShop.vue?vue&type=script&lang=js&"
import style0 from "./MyShop.vue?vue&type=style&index=0&id=4c92f327&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c92f327",
  null
  
)

export default component.exports